{
  "version": 1,
  "asset_id": "2d4d06bf-f30b-461b-acb2-5a9276ddfda8",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/2d4d06bf-f30b-461b-acb2-5a9276ddfda8/clip-img_2224-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/2d4d06bf-f30b-461b-acb2-5a9276ddfda8/clip-img_2224-poster-sm.webp",
  "original_filename": "clip-img_2224-poster-sm.webp",
  "size": 18982,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:38Z"
}
